module.exports = __webpack_public_path__ + "static/img/2_9.a370311e.png";